import {
  AlertOutlined,
  BellOutlined,
  CarOutlined,
  ClockCircleOutlined,
  ExperimentOutlined,
  DeploymentUnitOutlined,
  DropboxOutlined,
  FileTextOutlined,
  NodeIndexOutlined,
  OrderedListOutlined,
  PhoneOutlined,
  RadarChartOutlined,
  RobotOutlined,
  RollbackOutlined,
  ShoppingCartOutlined,
  SwapOutlined,
  SyncOutlined,
  TableOutlined,
  UserOutlined
} from "@ant-design/icons";
import { ApartmentOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router";
import { Link } from "react-router-dom";
import { fetchUserDetails } from "../../apis/user.api";
import { usePermissions } from "../../custom_hooks/permission/permission_hook";
import { canManageDelhivery } from "../../custom_hooks/use_delhivery_access";
import { ProcurementMobileLayout } from "./mobile";

const { Footer, Sider } = Layout;

const admin_ids = [
  "989abff0-93c1-443e-9c60-f1d36eaf63fe",
  "56f628c7-43e5-4122-a384-d62e705d8b5e",
  "3775b1f5-ddfb-4f54-95d2-4378b2d50f9d",
];

// const items: MenuProps["items"] = [
//   {
//     key: 1,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/clients"} className="text-decoration-none">
//         Clients
//       </Link>
//     ),
//   },
//   {
//     key: 2,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/pro-forma-invoices"} className="text-decoration-none">
//         PIs
//       </Link>
//     ),
//   },
//   {
//     key: 3,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/orders"} className="text-decoration-none">
//         Orders
//       </Link>
//     ),
//   },
//   {
//     key: 4,
//     icon: React.createElement(OrderedListOutlined),
//     label: (
//       <Link to={"/po-list"} className="text-decoration-none">
//         POs
//       </Link>
//     ),
//   },
//   {
//     key: 5,
//     icon: React.createElement(OrderedListOutlined),
//     label: (
//       <Link to={"/delivery-list"} className="text-decoration-none">
//         Delivery
//       </Link>
//     ),
//   },
//   {
//     key: 6,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/vendors"} className="text-decoration-none">
//         Vendors
//       </Link>
//     ),
//   },
//   {
//     key: 7,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/branch-details"} className="text-decoration-none">
//         Branch Details
//       </Link>
//     ),
//   },
//   {
//     key: 9,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/dashboard"} className="text-decoration-none">
//         Dashboard
//       </Link>
//     ),
//   },
//   {
//     key: 10,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/reports"} className="text-decoration-none">
//         Reports
//       </Link>
//     ),
//   },
//   {
//     key: 11,
//     icon: React.createElement(TableOutlined),
//     label: (
//       <Link to={"/procurement"} className="text-decoration-none">
//         Procurements
//       </Link>
//     ),
//   },
//   {
//     key: 12,
//     icon: React.createElement(TableOutlined),
//     label: (
//       <Link to={"/procurement-delivery"} className="text-decoration-none">
//         Assigned Delivery
//       </Link>
//     ),
//   },
//   {
//     key: 8,
//     icon: React.createElement(UserOutlined),
//     label: (
//       <Link to={"/user-profile"} className="text-decoration-none">
//         User Profile
//       </Link>
//     ),
//   },
// ];

// const admin_items: MenuProps["items"] = [
//   {
//     key: 1,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/clients"} className="text-decoration-none">
//         Clients
//       </Link>
//     ),
//   },
//   {
//     key: 2,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/pro-forma-invoices"} className="text-decoration-none">
//         PIs
//       </Link>
//     ),
//   },
//   {
//     key: 3,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/orders"} className="text-decoration-none">
//         Orders
//       </Link>
//     ),
//   },
//   {
//     key: 4,
//     icon: React.createElement(OrderedListOutlined),
//     label: (
//       <Link to={"/po-list"} className="text-decoration-none">
//         POs
//       </Link>
//     ),
//   },
//   {
//     key: 5,
//     icon: React.createElement(OrderedListOutlined),
//     label: (
//       <Link to={"/delivery-list"} className="text-decoration-none">
//         Delivery
//       </Link>
//     ),
//   },
//   {
//     key: 6,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/vendors"} className="text-decoration-none">
//         Vendors
//       </Link>
//     ),
//   },
//   {
//     key: 14,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/refunds"} className="text-decoration-none">
//         Refunds
//       </Link>
//     ),
//   },
//   {
//     key: 7,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/branch-details"} className="text-decoration-none">
//         Branch Details
//       </Link>
//     ),
//   },
//   {
//     key: 9,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/dashboard"} className="text-decoration-none">
//         Dashboard
//       </Link>
//     ),
//   },
//   {
//     key: 10,
//     icon: React.createElement(FileTextOutlined),
//     label: (
//       <Link to={"/reports"} className="text-decoration-none">
//         Reports
//       </Link>
//     ),
//   },
//   {
//     key: 11,
//     icon: React.createElement(TableOutlined),
//     label: (
//       <Link to={"/procurement"} className="text-decoration-none">
//         Procurements
//       </Link>
//     ),
//   },
//   {
//     key: 12,
//     icon: React.createElement(TableOutlined),
//     label: (
//       <Link to={"/procurement-delivery"} className="text-decoration-none">
//         Assigned Delivery
//       </Link>
//     ),
//   },
//   {
//     key: 8,
//     icon: React.createElement(UserOutlined),
//     label: (
//       <Link to={"/user-profile"} className="text-decoration-none">
//         User Profile
//       </Link>
//     ),
//   },
// ];

// Sidebar width. The Sider is position:fixed, so the content Layout offsets itself by
// the same value — keep these two in sync by reading the one constant.
const SIDER_WIDTH = 260;

// Submenu keys. Strings so they can never collide with the numeric leaf keys above.
const OMS_GROUP_KEY = "grp-oms";
const DELIVERY_GROUP_KEY = "grp-delivery";
const FINANCE_GROUP_KEY = "grp-finance";
const AGENTS_GROUP_KEY = "grp-agents";

// Which submenu each route lives under, so the right group is expanded on first paint.
// Routes absent from this map are top-level items and open nothing.
const ROUTE_GROUPS: Record<string, string> = {
  "/oms": OMS_GROUP_KEY,
  "/oms/logistics": OMS_GROUP_KEY,
  "/oms/availability": OMS_GROUP_KEY,
  "/oms/po": OMS_GROUP_KEY,
  "/oms/escalations": OMS_GROUP_KEY,
  "/oms/refunds": OMS_GROUP_KEY,
  "/oms/load-shift": OMS_GROUP_KEY,
  "/oms/testing": OMS_GROUP_KEY,
  "/delivery-control-tower": DELIVERY_GROUP_KEY,
  "/delivery-overall-control": DELIVERY_GROUP_KEY,
  "/oms/vendor-dashboard": DELIVERY_GROUP_KEY,
  "/warehouse-manager": DELIVERY_GROUP_KEY,
  "/delhivery-booking": DELIVERY_GROUP_KEY,
  "/delhivery-bookings": DELIVERY_GROUP_KEY,
  "/delhivery-multistop": DELIVERY_GROUP_KEY,
  "/cash-log": FINANCE_GROUP_KEY,
  "/refunds": FINANCE_GROUP_KEY,
  "/checkout": FINANCE_GROUP_KEY,
  "/design-agent": AGENTS_GROUP_KEY,
  "/design-agent-dashboard": AGENTS_GROUP_KEY,
  "/vendor-agent-dashboard": AGENTS_GROUP_KEY,
  "/call-intelligence": AGENTS_GROUP_KEY,
};

// Expands the submenu holding the current route. Only read on mount (defaultOpenKeys),
// so a group the user collapses by hand stays collapsed while they browse.
const getOpenKeys = () => {
  const group = ROUTE_GROUPS[window.location.pathname];
  return group ? [group] : [];
};

const getSelectedKey = () => {
  let currentPath = window.location.pathname;
  if (currentPath === "/clients" || currentPath === "/") {
    return ["1"];
  }
  // Keys are stable per route; the sidebar order and nesting live in getMenuItems, which
  // pushes Clients/PIs/Orders, then the OMS, Delivery, Procurement, Finance and Agents
  // submenus, then Vendors/Organisation Details/Sync/User Profile. These are leaf keys —
  // ROUTE_GROUPS above maps the same routes to the submenu that has to be open.
  switch (currentPath) {
    case "/":
    case "/clients":
      return ["1"];
    case "/pro-forma-invoices":
      return ["2"];
    case "/orders":
      return ["3"];
    case "/oms":
      return ["4"];
    case "/oms/logistics":
      return ["5"];
    case "/oms/availability":
      return ["6"];
    case "/oms/po":
      return ["7"];
    case "/oms/escalations":
      return ["34"];
    case "/oms/load-shift":
      return ["35"];
    case "/oms/refunds":
      return ["36"];
    case "/notifications":
      return ["8"];
    case "/po-list":
      return ["9"];
    case "/delivery-list":
      return ["10"];
    case "/delivery-list-v2":
      return ["11"];
    case "/warehouse-manager":
      return ["12"];
    case "/vendors":
      return ["13"];
    case "/branch-details":
      return ["14"];
    case "/procurement-cart":
      return ["15"];
    case "/inventory":
      return ["16"];
    case "/procurement":
      return ["17"];
    case "/cash-log":
      return ["18"];
    case "/refunds":
      return ["19"];
    case "/checkout":
      return ["20"];
    case "/procurement-new":
      return ["21"];
    case "/design-agent":
    case "/design-agent-dashboard":
      return ["22"];
    case "/vendor-agent-dashboard":
      return ["23"];
    case "/call-intelligence":
      return ["24"];
    case "/account":
    case "/sync":
      return ["25"];
    case "/delhivery-booking":
      return ["26"];
    case "/delhivery-bookings":
      return ["27"];
    case "/delhivery-multistop":
      return ["31"];
    case "/oms/testing":
      return ["28"];
    case "/user-profile":
      return ["29"];
    case "/delivery-control-tower":
      return ["30"];
    case "/delivery-overall-control":
      return ["33"];
    case "/oms/vendor-dashboard":
      return ["32"];
  }
  return ["0"];
};

const WebsiteLayout = () => {
  const [user, setUser] = useState<any>({});
  const { hasPermission } = usePermissions();
  const [online, setOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    fetchUserDetails().then((res) => {
      setUser(res);
      const userRole = localStorage.getItem("user_role");
      console.log("userRole", userRole);
      if (userRole != res?.branch?.user_permission.permission_name) {
        localStorage.setItem(
          "user_role",
          res?.branch?.user_permission.permission_name
        );
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    });
  }, []);

  const getMenuItems = () => {
    let menu_items: MenuProps["items"] = [];

    // Leaf keys stay exactly as they were so getSelectedKey() keeps matching; only the
    // nesting changed. Group keys are strings ("grp-*") so they can never collide with
    // a leaf key, and getOpenKeys() maps the current route back to its group.
    type MenuItems = NonNullable<MenuProps["items"]>;

    if (hasPermission("client.read")) {
      menu_items.push({
        key: 1,
        icon: React.createElement(FileTextOutlined),
        label: (
          <Link to={"/clients"} className="text-decoration-none">
            Clients
          </Link>
        ),
      });
    }

    if (hasPermission("pi.tab")) {
      menu_items.push({
        key: 2,
        icon: React.createElement(FileTextOutlined),
        label: (
          <Link to={"/pro-forma-invoices"} className="text-decoration-none">
            PIs
          </Link>
        ),
      });
    }

    if (hasPermission("order.read")) {
      menu_items.push({
        key: 3,
        icon: React.createElement(FileTextOutlined),
        label: (
          <Link to={"/orders"} className="text-decoration-none">
            Orders
          </Link>
        ),
      });
    }

    // ---- OMS group. Each entry gated by its own slug; the group is hidden entirely
    // when the user has none of them, so no empty dropdown can appear.
    const oms_children: MenuItems = [];

    if (hasPermission("oms.read")) {
      oms_children.push({
        key: 4,
        icon: React.createElement(DeploymentUnitOutlined),
        label: (
          <Link to={"/oms"} className="text-decoration-none">
            Overview
          </Link>
        ),
      });
    }

    if (hasPermission("oms.logistics")) {
      oms_children.push({
        key: 5,
        icon: React.createElement(CarOutlined),
        label: (
          <Link to={"/oms/logistics"} className="text-decoration-none">
            Operations
          </Link>
        ),
      });
    }

    if (hasPermission("oms.availability")) {
      oms_children.push({
        key: 6,
        icon: React.createElement(ClockCircleOutlined),
        label: (
          <Link to={"/oms/availability"} className="text-decoration-none">
            Availability
          </Link>
        ),
      });
    }

    if (hasPermission("oms.po")) {
      oms_children.push({
        key: 7,
        icon: React.createElement(OrderedListOutlined),
        label: (
          <Link to={"/oms/po"} className="text-decoration-none">
            PO
          </Link>
        ),
      });
    }

    // Kylas escalation tickets passed to procurement (pages/oms/escalations). Same gate as PO —
    // the procurement desk is who works these.
    if (hasPermission("oms.po")) {
      oms_children.push({
        key: 34,
        icon: React.createElement(AlertOutlined),
        label: (
          <Link to={"/oms/escalations"} className="text-decoration-none">
            Escalations
          </Link>
        ),
      });
    }

    if (hasPermission("oms.read")) {
      oms_children.push({
        key: 36,
        icon: React.createElement(RollbackOutlined),
        label: (
          <Link to={"/oms/refunds"} className="text-decoration-none">
            Refunds
          </Link>
        ),
      });
    }

    // Load shift (pages/oms/load_shift): prepone same-city backorders to a lighter day and convert
    // them to dropship. Rewrites live Zoho POs, so it shares the manual-overrides gate.
    if (hasPermission("oms.overrides")) {
      oms_children.push({
        key: 35,
        icon: React.createElement(SwapOutlined),
        label: (
          <Link to={"/oms/load-shift"} className="text-decoration-none">
            Load Shift
          </Link>
        ),
      });
    }

    // OMS Testing — only shown where REACT_APP_OMS_TESTING_ENABLED is set (dev box), never prod.
    if (process.env.REACT_APP_OMS_TESTING_ENABLED === "true") {
      oms_children.push({
        key: 28,
        icon: React.createElement(ExperimentOutlined),
        label: (
          <Link to={"/oms/testing"} className="text-decoration-none">
            Testing
          </Link>
        ),
      });
    }

    if (oms_children.length) {
      menu_items.push({
        key: OMS_GROUP_KEY,
        icon: React.createElement(DeploymentUnitOutlined),
        label: "OMS",
        children: oms_children,
      });
    }

    // ---- Delivery group: control tower, the delivery lists and the Delhivery tabs.
    const delivery_children: MenuItems = [];

    // Delivery Control Tower + Overall Control — both gated on `delivery.control_tower`
    // (default admin; the routes in routes.tsx use the same slug).
    if (hasPermission("delivery.control_tower")) {
      delivery_children.push({
        key: 30,
        icon: React.createElement(RadarChartOutlined),
        label: (
          <Link to={"/delivery-control-tower"} className="text-decoration-none">
            Control Tower
          </Link>
        ),
      });

      delivery_children.push({
        key: 33,
        icon: React.createElement(ApartmentOutlined),
        label: (
          <Link to={"/delivery-overall-control"} className="text-decoration-none">
            Overall Control
          </Link>
        ),
      });
    }

    // Vendor Dashboard (transporter view) — phase 1. Sits in Delivery beside Control Tower: it is
    // read by the delivery desk, not the OMS desk. Same gate as Operations (`oms.logistics`),
    // since it reads that board's endpoint.
    if (hasPermission("oms.logistics")) {
      delivery_children.push({
        key: 32,
        icon: React.createElement(CarOutlined),
        label: (
          <Link to={"/oms/vendor-dashboard"} className="text-decoration-none">
            Carrier Dashboard
          </Link>
        ),
      });
    }

    // Delhivery tabs — strict ROLE check (not the "admin" permission, which the role matrix also grants
    // to "tech"). Open to admin + the delivery team. The routes are guarded the same way via AdminRoute.
    const canDelhivery = canManageDelhivery(
      user?.branch?.user_permission?.permission_name
    );

    if (canDelhivery) {
      delivery_children.push({
        key: 26,
        icon: React.createElement(DropboxOutlined),
        label: (
          <Link to={"/delhivery-booking"} className="text-decoration-none">
            Book a Delhivery
          </Link>
        ),
      });

      delivery_children.push({
        key: 27,
        icon: React.createElement(OrderedListOutlined),
        label: (
          <Link to={"/delhivery-bookings"} className="text-decoration-none">
            Delhivery Bookings
          </Link>
        ),
      });

      delivery_children.push({
        key: 31,
        icon: React.createElement(NodeIndexOutlined),
        label: (
          <Link to={"/delhivery-multistop"} className="text-decoration-none">
            Multistop Pickup
          </Link>
        ),
      });
    }

    // Last in the Delivery group, below the Delhivery tabs — it is the warehouse desk's own screen,
    // not part of the delivery-booking flow above it.
    if (hasPermission("deliveryv2.tab")) {
      delivery_children.push({
        key: 12,
        icon: React.createElement(OrderedListOutlined),
        label: (
          <Link to={"/warehouse-manager"} className="text-decoration-none">
            Warehouse Manager
          </Link>
        ),
      });
    }

    if (delivery_children.length) {
      menu_items.push({
        key: DELIVERY_GROUP_KEY,
        icon: React.createElement(CarOutlined),
        label: "Delivery",
        children: delivery_children,
      });
    }

    if (hasPermission("procurement.carts")) {
      menu_items.push({
        key: 15,
        icon: React.createElement(ShoppingCartOutlined),
        label: (
          <Link to={"/procurement-cart"} className="text-decoration-none">
            Cart Availability
          </Link>
        ),
      });
    }

    // ---- Finance group. Hidden entirely when the user has none of the three slugs,
    // so no empty dropdown can appear.
    const finance_children: MenuItems = [];

    if (hasPermission("payment.read")) {
      finance_children.push({
        key: 18,
        icon: React.createElement(FileTextOutlined),
        label: (
          <Link to={"/cash-log"} className="text-decoration-none">
            Cash Log
          </Link>
        ),
      });
    }

    // The standalone Refunds sub-item was retired — refund settlements now live inside the
    // Cash Log's Refund tab, which reads from the wallet-backed `WalletTransaction` worklist
    // (see `oms/api/views/refunds.py`). The `/refunds` route itself is left in place so
    // bookmarks and OMS drill-down deep-links still resolve.

    if (hasPermission("order.details")) {
      finance_children.push({
        key: 20,
        icon: React.createElement(FileTextOutlined),
        label: (
          <Link to={"/checkout"} className="text-decoration-none">
            Checkout
          </Link>
        ),
      });
    }

    if (finance_children.length) {
      menu_items.push({
        key: FINANCE_GROUP_KEY,
        icon: React.createElement(FileTextOutlined),
        label: "Finance",
        children: finance_children,
      });
    }

    // if (hasPermission("po.read")) {
    //   menu_items.push({
    //     key: 11,
    //     icon: React.createElement(TableOutlined),
    //     label: (
    //       <Link to={"/procurement-delivery"} className="text-decoration-none">
    //         Assigned Delivery
    //       </Link>
    //     ),
    //   });
    // }

    // if (hasPermission("finance.read")) {
    //   menu_items.push({
    //     key: 18,
    //     icon: React.createElement(TableOutlined),
    //     label: (
    //       <Link to={"/finance"} className="text-decoration-none">
    //         Finance
    //       </Link>
    //     ),
    //   });
    // }

    // if (hasPermission("finance.read")) {
    //   menu_items.push({
    //     key: 17,
    //     icon: React.createElement(TableOutlined),
    //     label: (
    //       <Link to={"/po-margin-dashboard"} className="text-decoration-none">
    //         PO Margin Dashboard
    //       </Link>
    //     ),
    //   });
    // }

    // ---- Agents group. Vendor Agent and Call Intelligence are ungated, so this group
    // always has at least two entries.
    const agent_children: MenuItems = [];

    if (hasPermission("design_agent.dashboard")) {
      agent_children.push({
        key: 22,
        icon: React.createElement(TableOutlined),
        label: (
          <Link to={"/design-agent-dashboard"} className="text-decoration-none">
            Design Agent
          </Link>
        ),
      });
    }

    agent_children.push({
      key: 23,
      icon: React.createElement(RobotOutlined),
      label: (
        <Link to={"/vendor-agent-dashboard"} className="text-decoration-none">
          Vendor Agent
        </Link>
      ),
    });

    agent_children.push({
      key: 24,
      icon: React.createElement(PhoneOutlined),
      label: (
        <Link to={"/call-intelligence"} className="text-decoration-none">
          Call Intelligence
        </Link>
      ),
    });

    menu_items.push({
      key: AGENTS_GROUP_KEY,
      icon: React.createElement(RobotOutlined),
      label: "Agents",
      children: agent_children,
    });

    // ---- Ungrouped tail.
    if (hasPermission("vendor.read")) {
      menu_items.push({
        key: 13,
        icon: React.createElement(FileTextOutlined),
        label: (
          <Link to={"/vendors"} className="text-decoration-none">
            Vendors
          </Link>
        ),
      });
    }

    menu_items.push({
      key: 14,
      icon: React.createElement(FileTextOutlined),
      label: (
        <Link to={"/branch-details"} className="text-decoration-none">
          Organisation Details
        </Link>
      ),
    });

    // menu_items.push({
    //   key: 8,
    //   icon: React.createElement(FileTextOutlined),
    //   label: (
    //     <Link to={"/dashboard"} className="text-decoration-none">
    //       Dashboard
    //     </Link>
    //   ),
    // });

    // menu_items.push({
    //   key: 9,
    //   icon: React.createElement(FileTextOutlined),
    //   label: (
    //     <Link to={"/reports"} className="text-decoration-none">
    //       Reports
    //     </Link>
    //   ),
    // });

    if (hasPermission("inventory.read")) {
      menu_items.push({
        key: 16,
        icon: React.createElement(DropboxOutlined),
        label: (
          <Link to={"/inventory"} className="text-decoration-none">
            Inventory
          </Link>
        ),
      });
    }

    if (hasPermission("po.read")) {
      menu_items.push({
        key: 17,
        icon: React.createElement(TableOutlined),
        label: (
          <Link to={"/procurement"} className="text-decoration-none">
            Procurements
          </Link>
        ),
      });
    }

    // (Cash Log / Checkout live under the Finance submenu now — see above. The old ungrouped
    // top-level entries were removed on master when the Finance group landed.)

    if (hasPermission("po.read")) {
      menu_items.push({
        key: 21,
        icon: React.createElement(TableOutlined),
        label: (
          <Link to={"/procurement-new"} className="text-decoration-none">
            Procurements New
          </Link>
        ),
      });
    }

    if (hasPermission("sync.read") || hasPermission("zoho.account")) {
      menu_items.push({
        key: 25,
        icon: React.createElement(SyncOutlined),
        label: (
          <Link to={"/sync"} className="text-decoration-none">
            Sync
          </Link>
        ),
      });
    }

    // menu_items.push({
    //   key: 8,
    //   icon: React.createElement(BellOutlined),
    //   label: (
    //     <Link to={"/notifications"} className="text-decoration-none">
    //       Notifications
    //     </Link>
    //   ),
    // });

    if (hasPermission("po.read")) {
      menu_items.push({
        key: 9,
        icon: React.createElement(OrderedListOutlined),
        label: (
          <Link to={"/po-list"} className="text-decoration-none">
            POs
          </Link>
        ),
      });
    }

    if (hasPermission("delivery.list")) {
      menu_items.push({
        key: 10,
        icon: React.createElement(OrderedListOutlined),
        label: (
          <Link to={"/delivery-list"} className="text-decoration-none">
            Delivery List
          </Link>
        ),
      });
    }

    if (hasPermission("deliveryv2.tab")) {
      menu_items.push({
        key: 11,
        icon: React.createElement(OrderedListOutlined),
        label: (
          <Link to={"/delivery-list-v2"} className="text-decoration-none">
            Delivery V2
          </Link>
        ),
      });
    }

    menu_items.push({
      key: 29,
      icon: React.createElement(UserOutlined),
      label: (
        <Link to={"/user-profile"} className="text-decoration-none">
          User Profile
        </Link>
      ),
    });

    return menu_items;
  };

  return (
    <>
      <Layout
        hasSider
        style={{ minHeight: "100vh" }}
        className="d-sm-flex d-none"
      >
        {" "}
        <Sider
          width={SIDER_WIDTH}
          style={{
            overflow: "auto",
            // height: "vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
          }}
          className="shadow-sm"
        >
          <Link to={"/"} className="d-flex px-4 py-2 align-items-center">
            <img alt="logo" src="/main_logo.svg" className="w-75" />
          </Link>
          <Menu
            className="fw-bold sidebar-menu"
            mode="inline"
            selectedKeys={getSelectedKey()}
            defaultOpenKeys={getOpenKeys()}
            items={getMenuItems()}
            onClick={() => {}}
          />
        </Sider>
        <Layout className="site-layout" style={{ marginLeft: SIDER_WIDTH }}>
          {!online && (
            <div
              style={{
                backgroundColor: "#E41B17",
                color: "white",
                textAlign: "center",
              }}
              className="p-1"
            >
              You are offline. Please check your internet connection.
            </div>
          )}
          <Outlet />
          <Footer style={{ textAlign: "center" }}>
            Material Depot ©2023 Created by MDEPOT RETAIL TECHNOLOGIES PRIVATE
            LIMITED
          </Footer>
        </Layout>
      </Layout>
      <div className="d-sm-none d-block">
        <ProcurementMobileLayout />
      </div>
    </>
  );
};

export default WebsiteLayout;
